import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';
import isPromise from 'utils/predicates/isPromise.util';

const L = logger('tryAsync');

const tryAsync = (errorHandler, asyncFunction) => {
  if (isNotFn(errorHandler)) {
    return void L.error('()', 'Invalid errorHandler:', errorHandler);
  }

  if (isNotFn(asyncFunction)) {
    return void L.error('()', 'Invalid asyncFunction:', asyncFunction);
  }

  const result = asyncFunction();

  if (isPromise(result)) {
    result.catch(errorHandler);
  }

  return result;
};

// noinspection JSUnusedGlobalSymbols
export default tryAsync;
